import { useEffect } from 'react';
import CollectionPage from './CollectionPage';

export default function SoapstoneAnimals() {
  useEffect(() => { document.title = 'Peruvian Soapstone Animals | SpinWorld.Us'; }, []);
  return (
    <CollectionPage
      category="STONES"
      title="Hand-Carved in Peru"
      subtitle="Peruvian soapstone, each one unique"
      heroImage=""
      heroGradient
      description="Each soapstone animal is hand-carved by skilled artisans in the Peruvian Andes from natural soapstone, giving every piece its own unique color variations and character. No two are exactly alike — that is the beauty of handmade art from the earth."
    />
  );
}